import React from "react";
import { useParams } from "react-router-dom";
import { useOrg } from "../../../auth/OrgContext";
import { useAuth } from "../../../auth/AuthContext";
import { useProjects } from "../../../auth/ProjectContext";
import { Spinner, Callout } from "@blueprintjs/core";

const API_BASE =
  (process.env.REACT_APP_API_URL || "").replace(/\/$/, "") + "/api";

export default function ProjectDetailsPageWrapper() {
  return <ProjectDetails />;
}

function ProjectDetails() {
  const { projectId } = useParams();
  const { idToken } = useAuth();
  const { currentOrg, setCurrentOrg } = useOrg();
  const { projects, setCurrentProject } = useProjects();
  interface Project {
    id: string;
    name: string;
    orgId: string;
    orgName: string;
    created_at?: string;
  }
  const [project, setProject] = React.useState<Project | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!projectId) return;
    const p = projects.find((prj) => prj.id === projectId);
    if (p) {
      setCurrentProject(p);
      if (!currentOrg || currentOrg.id !== p.orgId) {
        setCurrentOrg({ id: p.orgId, name: p.orgName });
      }
    }
  }, [projects, projectId, currentOrg, setCurrentOrg, setCurrentProject]);

  React.useEffect(() => {
    if (!idToken || !currentOrg || !projectId) return;
    setLoading(true);
    fetch(`${API_BASE}/orgs/${currentOrg.id}/projects/${projectId}`, {
      headers: { Authorization: `Bearer ${idToken}` },
      credentials: "include",
    })
      .then(async (res) => {
        if (res.ok) {
          const data = await res.json();
          setProject(data);
          setCurrentProject(data);
        } else {
          setError("Project not found or you do not have access.");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Network error.");
        setLoading(false);
      });
  }, [idToken, currentOrg, projectId, setCurrentProject]);

  if (loading) return <Spinner size={30} style={{ margin: 40 }} />;
  if (error) return <Callout intent="danger">{error}</Callout>;
  if (!project) return null;

  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: "2rem 0" }}>
      <h2 style={{ marginBottom: 16 }}>{project.name}</h2>
      <div style={{ color: "#888", marginBottom: 16 }}>
        Project ID: {project.id}
      </div>
      <div style={{ color: "#888" }}>
        Created: {project.created_at ? new Date(project.created_at).toLocaleString() : "-"}
      </div>

      <Callout intent="primary" style={{ marginTop: "2rem" }} title="More features coming soon">
        This page will soon provide access to project-specific tests, reports and user
        permissions.
      </Callout>
    </div>
  );
}
